/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import styled, { css } from "styled-components";

const Flex = styled.div`
  display: flex;
  ${({ $gap }) => $gap && css`gap: ${$gap};`}
  ${({ $align }) => $align && css`align-items: ${$align};`}
  ${({ $justify }) => $justify && css`justify-content: ${$justify};`}
  ${({ $wrap }) => $wrap && css`flex-wrap: ${$wrap};`}
  ${({ $direction }) => $direction && css`flex-direction: ${$direction};`}
  ${({ $padding }) => $padding && css`padding: ${$padding};`}
`;

export default Flex;
